const apiUrl = {
  sandbox: "https://app-sandbox.thespotlight.pro",
  production: "https://app-api.thespotlight.pro",
};

type Environment = keyof typeof apiUrl;

const envName: Environment =
  (process.env.REACT_APP_ENV as Environment) ?? "production";

export const url = apiUrl[envName];

export const Post = async (
  endpoint: string,
  body: object | null
): Promise<any> => {
  return await post(url + endpoint, body);
};

export const Put = async (
  endpoint: string,
  body: object | null,
  headers?: object
): Promise<any> => {
  return await put(url + endpoint, body, headers);
};

export const Get = async (endpoint: string): Promise<any> => {
  return await get(url + endpoint);
};

export const Delete = async (endpoint: string): Promise<any> => {
  return await del(url + endpoint);
};

export const post = async (
  fullUrl: string,
  body: object | null
): Promise<any> => {
  const token = localStorage.getItem("jwtToken");

  let response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? "Bearer " + token : null,
    },
    body: body ? JSON.stringify(body) : JSON.stringify({}),
  });

  if (response.status === 403) {
    localStorage.removeItem("jwtToken");
    window.location.replace(`/login`);
  }

  if (response.status === 400) {
    throw new Error("Bad Request");
  }

  return await response.json().catch((e) => {
    return {};
  });
};

export const put = async (
  fullUrl: string,
  body: object | null,
  headers?: object
): Promise<any> => {
  const token = localStorage.getItem("jwtToken");

  let response = await fetch(fullUrl, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? "Bearer " + token : null,
      ...headers,
    },
    body: body ? JSON.stringify(body) : JSON.stringify({}),
  });

  return await response.json().catch((e) => {
    return {};
  });
};

export const get = async (fullUrl: string): Promise<any> => {
  const token = localStorage.getItem("jwtToken");

  let response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? "Bearer " + token : null,
    },
  });

  return await response.json().catch((e) => {
    return {};
  });
};

export const del = async (fullUrl: string): Promise<any> => {
  const token = localStorage.getItem("jwtToken");

  let response = await fetch(fullUrl, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? "Bearer " + token : null,
    },
  });

  if (
    response.headers.get("content-type") &&
    response.headers.get("content-type").includes("application/json")
  ) {
    return await response.json().catch((e) => {
      console.warn(e);
      return {};
    });
  }

  return response;
};
